import { Component, Input } from '@angular/core';

import { Pedido } from '../../pedido';

@Component({
    selector: 'sgt-pedido-setor-gep',
    templateUrl: './pedido-setor-gep.component.html',
    styleUrls: ['./pedido-setor-gep.component.less']
})
export class PedidoSetorGepComponent {
    @Input() entity: Pedido;
}
